// Import Create Slicer
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"; 
// Import Axios
import axios from "axios";

export const fetechAllCarBrands = createAsyncThunk('carBrandsSlicer/fetchAllBrands' , async()=>{
    const response = await axios.get('https://dashboard.djmotors.sa/api/v1/car-brands');

    return response.data.data;
})

export const carBrandsSlicer = createSlice({
    initialState: {
        brands: [], 
        status: 'OFF', 
        error: null
    },
    name: 'carBrandsSlicer',
    reducers: {},
    extraReducers: (builder)=>{
        builder.addCase(fetechAllCarBrands.pending , (state , action)=>{
            state.status = 'loading';
        }).addCase(fetechAllCarBrands.fulfilled , (state , action)=>{
            state.status = 'Success';
            state.brands = action.payload
        }).addCase(fetechAllCarBrands.rejected , (state , action)=>{
            state.status = 'Rejected';
            state.error = action.error.message
        })
    }
})


// Export the reducer
export default carBrandsSlicer.reducer;